module.exports = __webpack_public_path__ + "img/c03_buildingstartechtownwatch_Normal_ua.98842e68.webp";